import React from 'react';  
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import OnboardingForm from './components/OnboardingForm';
import ExistingProConnect from './components/ExistingProConnect';
import './styles.css';

// /connect-stripe is for Pros already in Caspio who only need Stripe payouts set up.
const isExistingProPage = window.location.pathname.replace(/\/+$/, '') === '/connect-stripe';
const Page = isExistingProPage ? ExistingProConnect : OnboardingForm;

document.addEventListener('DOMContentLoaded', () => {
    try {
        console.log('DOM loaded');
        const container = document.getElementById('onboarding-root');
        
        if (container) {
            console.log('Found container, creating root');
            const root = createRoot(container);
            console.log('Rendering OnboardingForm');
            root.render(
                <StrictMode>
                    <Page />
                </StrictMode>
            );
            console.log('OnboardingForm rendered');
        } else {
            console.error('Could not find onboarding-root element');
        }
    } catch (error) {
        console.error('React initialization error:', error);
    }
});